import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_zjatwgzdwa: FaireBrandEntity = {
  token: "b_zjatwgzdwa",
  type: "brand",
  name: "ButterBalm",
  avatarUrl:
    "https://cdn.faire.com/fastly/3d5f0b627668ca8bb8d4fc88aed124c70e00450d515eb0411e167305f5dca2ed.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/8157506cfe7d436eb052a0e854e1137c0c99859fe4d90bfa2f4556d160d81077.png",
  logoUrl:
    "https://cdn.faire.com/fastly/3d5f0b627668ca8bb8d4fc88aed124c70e00450d515eb0411e167305f5dca2ed.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/8157506cfe7d436eb052a0e854e1137c0c99859fe4d90bfa2f4556d160d81077.png",
  location: "Greenville, NC, USA",
  minimumOrderDollars: 50,
  rating: 5,
  reviewCount: 32,
  isInsider: true,
  description:
    "- Est March 2022,  North Carolina -\n\nAs a lover of the outdoors and a seeker of the sun, I was inspired to create a high quality product with a purpose. Having been raised along the Carolina Coast, I’ve always been drawn to coastal culture. I wanted to create a brand that inspired adventure and promoted a love for the outdoors. \n\nButterBalm is made with the purest possible ingredients and designed to seal and heal your lips so that you can go outside without fear of sun damage or dry air. Put our product to the test. It’ll make your lips smoother than you ever imagined…pinky promise. :) ",
  meta: {
    source: "api",
    importedAt: "2026-07-31T16:23:53.757Z",
    importedBy: "entity-db-cli",
  },
};
